"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ReachedCardWithTimerAndValue_1 = __importDefault(require("../ReachedCardWithTimerAndValue"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var DepositLimitReached = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useDepositLimit)().data;
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    if (!(data === null || data === void 0 ? void 0 : data.reached))
        return null;
    return (react_1.default.createElement(ReachedCardWithTimerAndValue_1.default, { title: t('depositLimitReached.title'), description: react_1.default.createElement("div", null,
            t('depositLimitReached.description'),
            react_1.default.createElement("br", null)), maxValue: formatCurrency((data === null || data === void 0 ? void 0 : data.maxValue) || 0), currentValue: formatCurrency((data === null || data === void 0 ? void 0 : data.currentValue) || 0), actionDescription: t('depositLimitReached.actionDescription'), limitName: t('depositLimit'), endDate: data === null || data === void 0 ? void 0 : data.expiresAt }));
};
exports.default = DepositLimitReached;
